// @ts-nocheck

import './App.css';
import { useDispatch, useSelector } from 'react-redux';
import AtomSnackbar from '@/components/atoms/Snakebar';
import { RootState } from '@/store';
import { hideSnackbar } from '@/store/snakebar/slice';
import Routers from './routers/router';

function App() {
  const dispatch = useDispatch();
  const snackbarState = useSelector((state: RootState) => state.snackbar);

  const handleClose = (event: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
    dispatch(hideSnackbar());
  };

  return (
    <div className="App">
      <Routers />
      <AtomSnackbar {...snackbarState} onClose={handleClose} />{' '}
    </div>
  );
}

export default App;
